import { createContext } from 'react';

type client = {
  client: Auth0LockPasswordlessStatic;
  isAuth: boolean;
};

/**
 * Auth0Clientを返す
 */
const auth0LockContext = createContext<client>({} as client);
export default auth0LockContext;

/**
 * localstorageよりセッション状態を取得
 *   true = ログイン中
 */
export const isAuthenticated = (): boolean => {
  const expiresAt = Number(localStorage.getItem('expires_at') ?? '0');

  return new Date().getTime() < expiresAt;
};
